import { useEffect, useState } from "react";

// Dialog yang baru dibuka kebal terhadap tap selama 400ms. Di HP, tap yang
// membuka dialog (mis. tombol "Buat") kadang diteruskan OS ke field yang
// muncul di bawah jari, sehingga dropdown/picker terbuka sendiri tanpa diklik.
// Guard ini menelannya; setelah 400ms interaksi kembali normal.
export function useEntryGuard(open, ms = 400) {
  const [guarded, setGuarded] = useState(false);
  useEffect(() => {
    if (!open) return;
    setGuarded(true);
    const t = setTimeout(() => setGuarded(false), ms);
    return () => clearTimeout(t);
  }, [open, ms]);
  return guarded;
}
